<script>
  import Issue from '../components/Issue.svelte';
  import Info from '../components/Info.svelte';
  import { isReady, issueItems } from '../data/dataAPI';

  import { issueSorting, hoveredIssuePage } from '../state/uiState';
</script>

<style type="text/scss">
  @import './styles/theme.scss';
  .controls {
    @include fluid-font-size($fs-base);
    @include fluid-space(padding-top, $sp-base);
    text-align: center;
    span {
      color: $c-gray-2;
      @include fluid-space(padding-right, $sp-xxsmall);
    }
    label {
      @include fluid-space(padding-right, $sp-xxsmall);
    }
    label:last-child {
      padding-right: 0;
    }
  }
  .items {
    @include fluid-space(margin-top, $sp-medium);
    @include fluid-space(margin-bottom, $sp-xlarge);
  }
</style>

{#if $isReady}
  <div class="controls">
    <span>Seiten sortieren nach</span>
    <label>
      <input type="radio" bind:group={$issueSorting} value={2} />
      Seitenzahl
    </label>
    <label>
      <input type="radio" bind:group={$issueSorting} value={1} />
      Anzahl infektiöser Wörter
    </label>
  </div>
  <div class="items">
    {#each $issueItems as d (d.id)}
      {#if d.type === 'issue'}
        <Issue
          id={d.id}
          name={d.name}
          date={d.date}
          pages={d.pages}
          words={d.words}
          sorting={$issueSorting}
          on:mouseover={d => {
            hoveredIssuePage.set(d.detail);
          }}
          on:mouseout={e => {
            hoveredIssuePage.set(undefined);
          }} />
      {:else}
        <Info text={d.text} date={d.date} link={d.link} />
      {/if}
    {/each}
  </div>
{:else}
  <p>Loading...</p>
{/if}
